// extracted by mini-css-extract-plugin
export default {"item":"Words_item__Oso2Q","word":"Words_word__gUPS2"};